module.exports = __webpack_public_path__ + "img/slogan_zhCn.b89d16a4.png";